module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-fundamentals-included_768.d9cf7c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hr-fundamentals-included_768.png
// module id = K90H
// module chunks = 0